module.exports = __webpack_public_path__ + "img/COMBO TWIRL PURPLE.b534903.svg";